'use strict';

// const _ = require('underscore');
const Base = require('components/Base/Base');
// const Events = require('constants/Events');
// const Constants = require('constants/Constants');

require('./PlatformHero.less');

const PlatformHeroVideoPopup = require('components/Platform/PlatformHeroVideoPopup/PlatformHeroVideoPopup');

const Selectors = {
    el: '.PlatformHero',
    playBtn: '.PlatformHero-playVideo'
};

const ChildViews = {
    'PlatformHeroVideoPopup': {
        selector: '.PlatformHeroVideoPopup',
        viewConstructor: PlatformHeroVideoPopup
    }
};

module.exports = Base.extend({

    el: Selectors.el,

    events: {
        'click .PlatformHero-playVideo': 'onPlayVideoClick'
    },

    initialize: function (options = {}) {
        Base.prototype.initialize.call(this, options);

        this.options = options;

        this.viewsRegistration(ChildViews);
    },

    onPlayVideoClick: function () {
        const videoId = $(Selectors.playBtn).data('video');

        this.views.PlatformHeroVideoPopup.openPopup(videoId);
    }
});
